var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c("drawer", {
        ref: "filterDrawer",
        scopedSlots: _vm._u([
          {
            key: "defult",
            fn: function () {
              return [
                _c(
                  "el-form-item",
                  { attrs: { label: "收益情况:" } },
                  [
                    _c(
                      "el-select",
                      {
                        on: {
                          change: function ($event) {
                            return _vm.toQuery()
                          },
                        },
                        model: {
                          value: _vm.listQuery.type,
                          callback: function ($$v) {
                            _vm.$set(_vm.listQuery, "type", $$v)
                          },
                          expression: "listQuery.type",
                        },
                      },
                      [
                        _c("el-option", {
                          attrs: { label: "连续2天无交易", value: 1 },
                        }),
                        _vm._v(" "),
                        _c("el-option", {
                          attrs: { label: "连续7天无交易", value: 2 },
                        }),
                        _vm._v(" "),
                        _c("el-option", {
                          attrs: { label: "连续15天无交易", value: 3 },
                        }),
                        _vm._v(" "),
                        _c("el-option", {
                          attrs: { label: "7天有交易", value: 4 },
                        }),
                      ],
                      1
                    ),
                  ],
                  1
                ),
                _vm._v(" "),
                _c(
                  "el-form-item",
                  { attrs: { label: "商户名称:" } },
                  [
                    _c("el-input", {
                      model: {
                        value: _vm.form.search_name,
                        callback: function ($$v) {
                          _vm.$set(_vm.form, "search_name", $$v)
                        },
                        expression: "form.search_name",
                      },
                    }),
                  ],
                  1
                ),
                _vm._v(" "),
                _c(
                  "el-form-item",
                  [
                    _c(
                      "el-button",
                      { attrs: { type: "primary", "native-type": "submit" } },
                      [
                        _vm._v("查询"),
                        _c("i", {
                          staticClass: "el-icon-search el-icon--right",
                        }),
                      ]
                    ),
                  ],
                  1
                ),
              ]
            },
            proxy: true,
          },
        ]),
      }),
      _vm._v(" "),
      _c("div", { staticClass: "p-5" }, [
        _c(
          "div",
          { staticClass: "bg-white" },
          [
            _c(
              "el-table",
              {
                directives: [
                  {
                    name: "loading",
                    rawName: "v-loading",
                    value: _vm.listLoading,
                    expression: "listLoading",
                  },
                ],
                ref: "equip_table",
                attrs: {
                  id: "equip_table",
                  data: _vm.list,
                  "element-loading-text": "Loading",
                  stripe: "",
                  "highlight-current-row": "",
                  "max-height": _vm.tableMaxH,
                },
              },
              [
                _c("el-table-column", {
                  attrs: { label: "商户名称" },
                  scopedSlots: _vm._u([
                    {
                      key: "default",
                      fn: function (scope) {
                        return [
                          _c(
                            "el-link",
                            {
                              attrs: {
                                href: "/shop/detail/" + scope.row.store_id,
                                target: "_blank",
                              },
                            },
                            [
                              _c(
                                "span",
                                { staticStyle: { color: "#409EFF" } },
                                [_vm._v(_vm._s(scope.row.store_name))]
                              ),
                            ]
                          ),
                        ]
                      },
                    },
                  ]),
                }),
                _vm._v(" "),
                _c("el-table-column", {
                  attrs: { label: "上级代理" },
                  scopedSlots: _vm._u([
                    {
                      key: "default",
                      fn: function (scope) {
                        return [
                          _vm._v(
                            "\n            " +
                              _vm._s(scope.row.role_name) +
                              "\n          "
                          ),
                        ]
                      },
                    },
                  ]),
                }),
                _vm._v(" "),
                _c("el-table-column", {
                  attrs: { label: "创建日期" },
                  scopedSlots: _vm._u([
                    {
                      key: "default",
                      fn: function (scope) {
                        return [
                          _vm._v(
                            "\n            " +
                              _vm._s(scope.row.add_date_des) +
                              "\n          "
                          ),
                        ]
                      },
                    },
                  ]),
                }),
                _vm._v(" "),
                _c("el-table-column", {
                  attrs: { label: "最后登录日期" },
                  scopedSlots: _vm._u([
                    {
                      key: "default",
                      fn: function (scope) {
                        return [
                          _vm._v(
                            "\n            " +
                              _vm._s(scope.row.business_last_date_des) +
                              "\n          "
                          ),
                        ]
                      },
                    },
                  ]),
                }),
                _vm._v(" "),
                _c("el-table-column", {
                  attrs: { label: "交易停止" },
                  scopedSlots: _vm._u([
                    {
                      key: "default",
                      fn: function (scope) {
                        return [
                          _vm._v(
                            "\n            " +
                              _vm._s(scope.row.business_des) +
                              "\n          "
                          ),
                        ]
                      },
                    },
                  ]),
                }),
                _vm._v(" "),
                _c("el-table-column", {
                  attrs: { label: "联系人" },
                  scopedSlots: _vm._u([
                    {
                      key: "default",
                      fn: function (scope) {
                        return [
                          _c("span", { staticClass: "mr-15" }, [
                            _vm._v(_vm._s(scope.row.name)),
                          ]),
                          _vm._v(" "),
                          _c("span", [_vm._v(_vm._s(scope.row.phone))]),
                        ]
                      },
                    },
                  ]),
                }),
                _vm._v(" "),
                _c("el-table-column", {
                  attrs: { label: "跟进记录" },
                  scopedSlots: _vm._u([
                    {
                      key: "default",
                      fn: function (scope) {
                        return [
                          _c(
                            "el-tooltip",
                            {
                              attrs: {
                                content: scope.row.cs_record,
                                placement: "top",
                                "popper-class": "content-tooltip",
                              },
                            },
                            [
                              _c("div", { staticClass: "content-cell" }, [
                                _vm._v(_vm._s(scope.row.cs_record)),
                              ]),
                            ]
                          ),
                        ]
                      },
                    },
                  ]),
                }),
                _vm._v(" "),
                _c("el-table-column", {
                  attrs: { label: "跟进时间" },
                  scopedSlots: _vm._u([
                    {
                      key: "default",
                      fn: function (scope) {
                        return [
                          _vm._v(
                            "\n            " +
                              _vm._s(scope.row.cs_add_date) +
                              "\n          "
                          ),
                        ]
                      },
                    },
                  ]),
                }),
                _vm._v(" "),
                _c("el-table-column", {
                  attrs: { label: "跟进人" },
                  scopedSlots: _vm._u([
                    {
                      key: "default",
                      fn: function (scope) {
                        return [
                          _vm._v(
                            "\n            " +
                              _vm._s(scope.row.cs_add_person) +
                              "\n          "
                          ),
                        ]
                      },
                    },
                  ]),
                }),
                _vm._v(" "),
                _c("el-table-column", {
                  attrs: { label: "操作" },
                  scopedSlots: _vm._u([
                    {
                      key: "default",
                      fn: function (scope) {
                        return [
                          scope.row.cs_store_id
                            ? _c(
                                "el-button",
                                {
                                  staticClass: "ml-0",
                                  attrs: {
                                    type: "primary",
                                    size: "mini",
                                    round: "",
                                    plain: "",
                                  },
                                  on: {
                                    click: function ($event) {
                                      return _vm.handleViewCustomerDetail(
                                        scope.row
                                      )
                                    },
                                  },
                                },
                                [_vm._v("更多跟进详情")]
                              )
                            : _vm._e(),
                          _vm._v(" "),
                          _c(
                            "el-button",
                            {
                              staticClass: "ml-0",
                              attrs: {
                                type: "primary",
                                size: "mini",
                                round: "",
                                plain: "",
                              },
                              on: {
                                click: function ($event) {
                                  return _vm.handleCreateCustomerRecord(
                                    scope.row
                                  )
                                },
                              },
                            },
                            [_vm._v("创建跟进记录")]
                          ),
                        ]
                      },
                    },
                  ]),
                }),
              ],
              1
            ),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "flex justify-center" },
              [
                _c("pagination", {
                  directives: [
                    {
                      name: "show",
                      rawName: "v-show",
                      value: _vm.listQuery.page_num > 0,
                      expression: "listQuery.page_num > 0",
                    },
                  ],
                  attrs: {
                    page: _vm.listQuery.start,
                    "page-count": _vm.listQuery.page_num,
                    limit: _vm.listQuery.limit,
                  },
                  on: {
                    "update:page": function ($event) {
                      return _vm.$set(_vm.listQuery, "start", $event)
                    },
                    "update:limit": function ($event) {
                      return _vm.$set(_vm.listQuery, "limit", $event)
                    },
                    pagination: _vm.getList,
                  },
                }),
              ],
              1
            ),
          ],
          1
        ),
      ]),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }